/*
 * 気になる説明会機能
 *  チェックのつけ外し、ajaxでデータを送る
 */
$(function() {
  $('.favorite_career_fair').on('click', function() {
    let url = $(this).data('url');
    $.ajax({
      url: url,
      type: 'POST',
      dataYpe: 'json',
    }).done(function(data) {
      //　特に何もしない
    })
    .fail(function(data) {
      if(data.status == 403) {
        // リダイレクトURL先へ遷移する
          location.href = data.responseJSON.redirect_url;
      } else {
          alert('想定外のエラーが発生しました。\nページを再読み込みしてください。');
      }
    });
  });
});
